import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from '@souche-f2e/muji';
import { Carousel } from 'antd';
import { judgeArr } from '@/shared/functions';
const Root = styled.div `
  width: 100%;
  height: 100%;
  .ant-carousel, .slick-slider, .slick-list, .slick-track, .slick-slide {
    height: 100%;
    div, img {
      height: 100%;
    }
  }
  .ant-carousel .slick-dots {
    li button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      opacity: 1;
    }
    li.slick-active button {
      width: 10px;
      background-color: #ff4040;
    }
  }
`;
const mapStateToProps = (rootState) => ({
    _state: rootState.carImgs,
});
class CarImgs extends Component {
    shouldComponentUpdate(nextProps) {
        const oldImgs = JSON.stringify(this.props._state.imgs);
        const newImgs = JSON.stringify(nextProps._state.imgs);
        if (oldImgs === newImgs) {
            return false;
        }
        return true;
    }
    render() {
        const { imgs } = this.props._state;
        const { className, style, defaultImg } = this.props;
        const dealImgs = judgeArr(imgs) ? imgs : defaultImg ? defaultImg : [];
        return (<Root className={className} style={style}>
        <Carousel autoplay>
            {judgeArr(dealImgs) && dealImgs.map((item, i) => (<img src={item.photoPathSamll} key={`carImgs_${i}`}/>))}
        </Carousel>
      </Root>);
    }
}
export default connect(mapStateToProps)(CarImgs);
